<script setup lang="ts">
import { cn } from '@/lib/utils';
import { useAttrs } from 'vue';
import { useCarousel } from './useCarousel';

defineOptions({ inheritAttrs: false });

const { orientation } = useCarousel();
const attrs = useAttrs();
</script>

<template>
  <div
    role="group"
    aria-roledescription="slide"
    :class="
      cn('min-w-0 shrink-0 grow-0 basis-full', orientation === 'horizontal' ? 'pl-4' : 'pt-4', attrs.class as string)
    "
  >
    <slot />
  </div>
</template>
